import { DOCUMENT, inject, Injectable } from '@angular/core';
import type { OrderHistoryFilter, OrderHistorySortByValueType } from '@libs/services/models';
import { SORT_BY_TRACKING_MAP } from '@libs/shared/models';
import { DateTime } from 'luxon';
import { getTrackingPagePath } from '../context';
import { TrackingGoogleService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class OrderHistoryTrackingService {
  private readonly document: Document = inject(DOCUMENT);
  private readonly tracking: TrackingGoogleService = inject(TrackingGoogleService);

  public trackSort(sort: OrderHistorySortByValueType | undefined): void {
    this.tracking.trackEvent('sortByType', {
      location: getTrackingPagePath(this.document),
      sortByType: sort ? SORT_BY_TRACKING_MAP[sort] : null,
    });
  }

  public trackFilter(filter: OrderHistoryFilter): void {
    this.tracking.trackEvent('filter', {
      location: getTrackingPagePath(this.document),
      availabilityFilter: this.formatAvailabilityFilter(filter),
      deliveryDateFilter: this.formatDateRange(filter.shipping?.from, filter.shipping?.to),
      orderDateFilter: this.formatDateRange(filter.order?.from, filter.order?.to),
    });
  }

  private formatAvailabilityFilter(filter: OrderHistoryFilter): string | null {
    if (!filter.delivery) {
      return null;
    }

    return filter.delivery === 'partial'
      ? 'unvollständige Lieferung'
      : 'vollständige Lieferung';
  }

  private formatDateRange(from: DateTime | undefined, to: DateTime | undefined): string | null {
    if (!from && !to) {
      return null;
    }

    const start: string | null = from?.toISODate()?.replace(/-/g, '') ?? null;
    const end: string | null = to?.toISODate()?.replace(/-/g, '') ?? null;

    return `${start}-${end}`;
  }
}
